import { useActiveSubscriptions } from './useActiveSubscriptions'

const useActiveCgmSubscriptions = () => {
  const subscriptions = useActiveSubscriptions()

  return subscriptions.filter((subscription) => subscription.primaryProduct.includesCgm)
}

export const useHasActiveCgmSubscription = () => {
  const subscriptions = useActiveCgmSubscriptions()

  return subscriptions.length > 0
}
